const ASSET_BASE = process.env.PUBLIC_URL || "";

export interface BlogPost {
  id: number;
  href: string;
  title: string;
  date: string;
  excerpt: string;
  img: {
    src: string;
    alt: string;
    srcSet?: string;
    sizes?: string;
    width: number;
    height: number;
    loading?: "lazy";
  };
}

const blogPostsData = [
  {
    id: 7254,
    slug: "thriving-in-diversity-cultivating-trust-and-camaraderie-in-global-teams",
    title:
      "Thriving in Diversity: Cultivating Trust and Camaraderie in Global Teams",
    date: "Sep 13, 2024",
    excerpt:
      "In my previous blog, I detailed my journey from a junior merchandiser to General Manager of...",
    imagePath: "bp1.png",
  },
  {
    id: 7221,
    slug: "the-anatomy-of-high-performing-teams-part-2",
    title: "The Anatomy of High-Performing Teams – Part 2",
    date: "Aug 5, 2024",
    excerpt:
      "A leader can't achieve success alone or merely by pulling together individuals with the right...",
    imagePath: "bp2.png",
  },
  {
    id: 6921,
    slug: "the-anatomy-of-high-performing-teams-part-1",
    title: "The Anatomy of High-Performing Teams – Part 1",
    date: "May 28, 2024",
    excerpt:
      "What defines a stellar team? It's a complex and broad question, one that demands exploration....",
    imagePath: "bp3.png",
  },
  {
    id: 6879,
    slug: "leading-with-purpose-a-pc-perspective",
    title: "Leading with Purpose: A P&C Perspective",
    date: "Apr 30, 2024",
    excerpt:
      "At the heart of every thriving organization lies its people—the driving force behind its...",
    imagePath: "bp4.png",
    loading: "lazy" as const,
  },
  {
    id: 6811,
    slug: "climbing-the-ladder-learning-adapting-and-leading-with-authenticity",
    title:
      "Climbing the Ladder: Learning, Adapting, and Leading with Authenticity",
    date: "Mar 11, 2024",
    excerpt:
      "Welcome to the fast-paced world of apparel sourcing, where leadership goes beyond mere...",
    imagePath: "bp5.png",
    loading: "lazy" as const,
  },
];

export const blogPosts: BlogPost[] = blogPostsData.map((post) => {
  const imageUrl = `${ASSET_BASE}/assets/${post.imagePath}`;

  return {
    id: post.id,
    href: `/blogs/${post.slug}`,
    title: post.title,
    date: post.date,
    excerpt: post.excerpt,
    img: {
      src: imageUrl,
      alt: post.title,
      srcSet: `${imageUrl} 479w, ${imageUrl} 480w`,
      sizes: "(max-width:479px) 479px, 100vw",
      width: 400,
      height: 250,
      ...(post.loading && { loading: post.loading }),
    },
  };
});
